export enum urlShortenerRoutes {
  root = 'custom-url-shortener',
}
